import React, { useEffect, useRef } from 'react';
import { Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import { forgotPassword, UI_OPERATION_STATUS_ERROR, CoreLink } from '@uncinc/react-drupal-core';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Helmet } from 'react-helmet';

import { Button, EmailField } from '../../../components';
import { clearPageInformation, setPageInformation, setPageViewSent } from '../../../store/actions/UI';
import { DEFAULT_LANGUAGE } from '../../../config/constants';
import { ROUTE_CUSTOMER_SERVICE } from '../../../config/routes';

import LogoImageVNL from '../../../assets/images/VNL_logo_clean.svg';

import './style.scss';

const UserRequestPassword = () => {
  const PAGE_TITLE = 'Wachtwoord vergeten | VeiligheidNL';
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], null));
  const requestStatus = useSelector((state) => state.getIn(['ui', 'user', 'operations', 'forgot_password', 'status'], null));
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const formikRef = useRef();

  // Redirect to home if logged in.
  useEffect(() => {
    if (loggedIn) {
      history.push('/');
    }
  }, [loggedIn, history]);

  useEffect(() => {
    dispatch(clearPageInformation());
    dispatch(setPageInformation(PAGE_TITLE));
    dispatch(setPageViewSent(false));
  }, []);

  const onSubmit = ({ email }) => {
    dispatch(forgotPassword(email));
  };

  useEffect(() => {
    if (requestStatus === 'UI_OPERATION_STATUS_SUCCESS') {
      history.push('/success/requestpassword');
    }
  }, [requestStatus, history]);

  return (
    <>
      <Helmet htmlAttributes={{ lang: DEFAULT_LANGUAGE }}>
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container small>
        <div className="FormPage RequestPassword PageMinimal">
          {requestStatus !== 'UI_OPERATION_STATUS_SUCCESS' && (
            <div>
              <div className="PageMinimal__top">
                <CoreLink className="Logo" href="https://www.veiligheid.nl">
                  <img src={LogoImageVNL} alt="VeiligheidNL" />
                </CoreLink>
                <h1>{t('request_password.title')}</h1>
              </div>
              <div className="PageMinimal__content">
                <p>{t('request_password.description')}</p>

                {(requestStatus === UI_OPERATION_STATUS_ERROR) && (
                  <div className="Form__error">Er is iets mis gegaan. Probeer het later nog eens.</div>
                )}
                <FormikWrapper
                  innerRef={formikRef}
                  initialValues={{ email: '', api: '' }}
                  validationSchema={yup.object().shape({
                    email: yup
                      .string()
                      .email(t('login.email.invalid'))
                      .required(t('login.email.required')),
                  })}
                  onSubmit={(values, { setSubmitting }) => {
                    onSubmit(values);
                    setSubmitting(false);
                  }}
                >
                  <EmailField
                    fieldName="email"
                    title="E-mail"
                    required
                  />
                  <Button htmlType="submit">
                    {t('request_password.submit')}
                  </Button>
                </FormikWrapper>
              </div>
            </div>
          )}
          <div className="PageMinimal__usp">
            <div className="PageMinimal__usp__link">
              <CoreLink href={ROUTE_CUSTOMER_SERVICE} target="_blank" className="Button Button--secondary Button--help">
                {t('general.need_help')}
              </CoreLink>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default UserRequestPassword;
